import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import toast from '../../shared/Toast';
import './ReceptionModals.css';

class VerifyResetPinModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pin: '',
            pinError: '',
            isSubmitting: false
        };
    }

    handlePinChange = (e) => {
        const pin = e.target.value;
        if (/^\d{0,6}$/.test(pin)) {
            this.setState({ pin, pinError: '' });
        }
    }

    validateForm = () => {
        const { pin } = this.state;
        if (!pin || pin.length !== 6) {
            this.setState({ pinError: 'The code is 6 digits' });
            return false;
        }
        return true;
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validateForm()) {
            this.setState({ isSubmitting: true });
            try {
                this.props.onVerifyResetPin(this.state.pin);
                setTimeout(() => {
                    if (this.state.isSubmitting) {
                        this.setState({ isSubmitting: false });
                    }
                }, 500);
            } catch (error) {
                console.error('Error in PIN verification:', error);
                toast.error('An error occurred during verification. Please try again.');
                this.setState({ isSubmitting: false, pin: '' });
            }
        }
    }

    render() {
        const { onClose } = this.props;
        const { pin, pinError, isSubmitting } = this.state;

        return ReactDOM.createPortal(
            <div className="rm-modal-overlay" onClick={onClose}>
                <div className="rm-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="rm-modal-header">
                        <h3>Reset PIN</h3>
                        <button className="rm-modal-close" onClick={onClose} type="button">&times;</button>
                    </div>
                    <div className="rm-modal-body">
                        <p>A verification code has been sent to your email. Enter the 6-digit code below to reset your PIN. It works for 15 minutes.</p>
                        <form onSubmit={this.handleSubmit}>
                            <div className="rm-form-group">
                                <label className="rm-label" htmlFor="resetCode">Enter Verification Code</label>
                                <input
                                    type="text"
                                    className={`rm-input${pinError ? ' rm-input--error' : ''}`}
                                    id="resetCode"
                                    value={pin}
                                    onChange={this.handlePinChange}
                                    placeholder="6-digit code"
                                    inputMode="numeric"
                                    maxLength={6}
                                    disabled={isSubmitting}
                                    autoFocus
                                />
                                {pinError && <span className="rm-error">{pinError}</span>}
                            </div>
                            <div className="rm-modal-footer">
                                <button
                                    type="button"
                                    className="rm-btn rm-btn--secondary"
                                    onClick={onClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="rm-btn rm-btn--primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Verifying...' : 'Continue'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>,
            document.body
        );
    }
}

export default VerifyResetPinModal;
